"use client";

import IconCheck from "@/app/(components)/generics/Icons/IconCheck";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { fillPricingText } from "./Pricing.logic";
import styles from "./Pricing.module.css";

type Props = {
  features: TKey[];
  values?: Record<string, string | number>;
};

export default function PricingFeatures(props: Props) {
  const T = useT();
  const { features, values = {} } = props;

  return (
    <ul className={styles.features}>
      {features.map((feature) => (
        <li className={styles.feature} key={feature}>
          <IconCheck color="var(--color-green-3)" />
          <span className={styles.featureText}>{fillPricingText(T(feature), values)}</span>
        </li>
      ))}
    </ul>
  );
}
